var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconPlain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60916_17841)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.625 7.06836H1.8125C1.3295 7.06836 0.9375 7.46036 0.9375 7.94336C0.9375 8.42636 1.3295 8.81836 1.8125 8.81836H6.625V13.6309C6.625 14.1139 7.017 14.5059 7.5 14.5059C7.983 14.5059 8.375 14.1139 8.375 13.6309V8.81836H13.1875C13.6705 8.81836 14.0625 8.42636 14.0625 7.94336C14.0625 7.46036 13.6705 7.06836 13.1875 7.06836H8.375V2.25586C8.375 1.77286 7.983 1.38086 7.5 1.38086C7.017 1.38086 6.625 1.77286 6.625 2.25586V7.06836Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60916_17841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.943359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconPlain);
export default __webpack_public_path__ + "static/media/PlusIconPlain.be92375665fb57287a01e8ec6739ee46.svg";
export { ForwardRef as ReactComponent };